import React from 'react';

/**
 * Legal footer for authenticated dashboard — matches LandingPage footer link styling.
 */
export function DashboardFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="mt-10 border-t border-slate-200 dark:border-border bg-white dark:bg-card -mx-4 md:-mx-8 lg:-mx-10 px-4 md:px-8 lg:px-10 pt-8 pb-10"
      data-testid="dashboard-footer"
    >
      <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
        <a
          href="https://www.docmania.co/privacy"
          data-testid="dashboard-privacy-link"
          className="text-sm font-medium text-slate-600 dark:text-muted-foreground hover:text-slate-900 dark:hover:text-foreground transition-colors"
        >
          Privacy
        </a>
        <a
          href="https://www.docmania.co/terms"
          data-testid="dashboard-terms-link"
          className="text-sm font-medium text-slate-600 dark:text-muted-foreground hover:text-slate-900 dark:hover:text-foreground transition-colors"
        >
          Terms
        </a>
        <a
          href="https://www.docmania.co/pricing"
          data-testid="dashboard-pricing-link"
          className="text-sm font-medium text-slate-600 dark:text-muted-foreground hover:text-slate-900 dark:hover:text-foreground transition-colors"
        >
          Pricing
        </a>
        <a
          href="https://www.docmania.co/refund-policy"
          data-testid="dashboard-refund-policy-link"
          className="text-sm font-medium text-slate-600 dark:text-muted-foreground hover:text-slate-900 dark:hover:text-foreground transition-colors"
        >
          Refund Policy
        </a>
        <a
          href="https://www.docmania.co/contact"
          data-testid="dashboard-contact-link"
          className="text-sm font-medium text-slate-600 dark:text-muted-foreground hover:text-slate-900 dark:hover:text-foreground transition-colors"
        >
          Contact
        </a>
      </nav>
      <p className="mt-6 text-center text-sm text-slate-500 dark:text-muted-foreground">
        © {year} DocMania. All rights reserved.
      </p>
    </footer>
  );
}
